import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import "./home-header.css";

const HomeHeader = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLinkClick = (e, hash) => {
    e.preventDefault(); // Prevent the default anchor tag behavior
    setIsMenuOpen(false);

    // If we are already on the homepage, just scroll
    if (location.pathname === "/") {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // If we are on another page, navigate to the homepage with the hash
      navigate(`/${hash}`);
    }
  };

  const menuVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0, transition: { staggerChildren: 0.1 } },
    exit: { opacity: 0, y: -20 },
  };

  const menuItemVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <header className={`home-header ${isScrolled ? "scrolled" : ""}`}>
      <div className="home-header-container">
        <a href="/" className="logo-link">
          <img
            src={`${process.env.PUBLIC_URL}/assets/direct-logo-dark.svg`}
            alt="Direct by Syndicate Bio"
            className="logo"
          />
        </a>

        <div className="header-desktop-nav">
          <nav className="desktop-nav">
            <a href="#our-tests" onClick={(e) => handleLinkClick(e, "#our-tests")}>
              Our tests
            </a>
            <a href="#how-it-works" onClick={(e) => handleLinkClick(e, "#how-it-works")}>
              How it works
            </a>
            <a href="#why-choose-us" onClick={(e) => handleLinkClick(e, "#why-choose-us")}>
              Why choose us?
            </a>
            <Link to="/genetic-counselors">Genetic Counselors</Link>
          </nav>

          <div className="header-actions">
            <a
              href="/login"
              onClick={(e) => {
                e.preventDefault();
                navigate("/login");
              }}
              className="contact-us-button"
            >
              Login
            </a>
            <button
              className="mobile-menu-toggle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? (
                <X size={28} color="#171b40" />
              ) : (
                <Menu color="#171b40" size={28} />
              )}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.nav
            className="mobile-nav"
            variants={menuVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <motion.a
              variants={menuItemVariants}
              href="#our-tests"
              onClick={(e) => handleLinkClick(e, "#our-tests")}
            >
              Our tests
            </motion.a>
            <motion.a
              variants={menuItemVariants}
              href="#how-it-works"
              onClick={(e) => handleLinkClick(e, "#how-it-works")}
            >
              How it works
            </motion.a>
            <motion.a
              variants={menuItemVariants}
              href="#why-choose-us"
              onClick={(e) => handleLinkClick(e, "#why-choose-us")}
            >
              Why choose us?
            </motion.a>
            <motion.div variants={menuItemVariants}>
              <Link
                to="/genetic-counselors"
                onClick={() => setIsMenuOpen(false)}
              >
                Genetic Counselors
              </Link>
            </motion.div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default HomeHeader;